import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    vendor_id: '',
    vendor_badanhukum: '',
    vendor_shortname: '',
    vendor_name: '',
    vendor_namereport: '',
    vendor_address: '',
    vendor_city: '',
    vendor_telp: '',
    vendor_fax: '',
    vendor_email: '',
    vendor_url: '',
    vendor_isdisabled: 0,
    vendor_type: '',
    vendor_bankname: '',
    vendor_accountno: '',
    vendor_accountholder: '',
    vendor_ispkp: 0,
    vendor_contact: [],
    vendor_createdby: '',
    vendor_createddate: '',
    vendor_modifyby: '',
    vendor_modifydate: '',
    rowid: '',
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
  selectedContactId: null,
};

const mst07vendorSlice = createSlice({
  name: 'mst07vendor',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; state.selectedContactId = null; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    setSelectedContactId: (state, action) => { state.selectedContactId = action.payload; },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.selectedContactId = null;
      state.formData = initialState.formData;
    },
  },
});

export const {
  setSelectedRow,
  setFormData,
  clearFormData,
  setLoading,
  setErrorMsg,
  setLoadingMessage,
  setDataList,
  setTotalData,
  fetchDetailSuccess,
  fetchDetailFailure,
  fetchDetailError,
  updateFormData,
  setSelectedContactId,
  resetState,
  setActiveTab,
  clearModuleState,
} = mst07vendorSlice.actions;

export default mst07vendorSlice.reducer;
